/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssistAnswer,
  AssistMessage,
  AssistMessageCreate,
  AssistMessagePage,
  AssistRequest,
  CaptionPreset,
  CaptionPresetCreate,
  EditProject,
  EditProjectChanges,
  EditProjectCreate,
  EditProjectFromAsset,
  EditProjectMedia,
  EditProjectPage,
  EditProjectUpdate,
  EditRender,
  EditRenderFile,
  EditRenderFileRequest,
  EditRenderRequest,
  ErrorEnvelope,
  GetEditProjectChangesParams,
  HandEditRenderToServerHeaders,
  ListAssistMessagesParams,
  ListEditProjectsParams,
  StartAssistAnswerHeaders,
  StartEditRenderHeaders
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListEditProjectsUrl = (teamId: string,
    brandId: string,
    params?: ListEditProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects`
}

/**
 * The brand's projects, the latest changed first, a page of summaries with each one's
 * picture (spec editor/project-list-pages.md), for every member (D6).
 * @summary List Edit Projects
 */
export const listEditProjects = async (teamId: string,
    brandId: string,
    params?: ListEditProjectsParams, options?: Parameters<typeof apiRequest>[1]): Promise<EditProjectPage> => {

  return apiRequest<EditProjectPage>(getListEditProjectsUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEditProjectsQueryKey = (teamId: string,
    brandId: string,
    params?: ListEditProjectsParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEditProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listEditProjects>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListEditProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditProjects>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEditProjectsQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEditProjects>>> = ({ signal }) => listEditProjects(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEditProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEditProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listEditProjects>>>
export type ListEditProjectsQueryError = ErrorType<ErrorEnvelope>


export function useListEditProjects<TData = Awaited<ReturnType<typeof listEditProjects>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListEditProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEditProjects>>,
          TError,
          Awaited<ReturnType<typeof listEditProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEditProjects<TData = Awaited<ReturnType<typeof listEditProjects>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListEditProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEditProjects>>,
          TError,
          Awaited<ReturnType<typeof listEditProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEditProjects<TData = Awaited<ReturnType<typeof listEditProjects>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListEditProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditProjects>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Edit Projects
 */

export function useListEditProjects<TData = Awaited<ReturnType<typeof listEditProjects>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListEditProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditProjects>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEditProjectsQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateEditProjectUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects`
}

/**
 * A new project of the brand, empty unless the request has a timeline.
 * @summary Create Edit Project
 */
export const createEditProject = async (teamId: string,
    brandId: string,
    editProjectCreate: EditProjectCreate, options?: Parameters<typeof apiRequest>[1]): Promise<EditProject> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<EditProject>(getCreateEditProjectUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editProjectCreate)
  }
);}





export const getCreateEditProjectMutationKey = () => ['createEditProject'] as const;

export const getCreateEditProjectMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditProject>>, TError,CreateEditProjectMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createEditProject>>, TError,CreateEditProjectMutationVariables, TContext> => {

const mutationKey = getCreateEditProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEditProject>>, CreateEditProjectMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  createEditProject(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEditProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createEditProject>>>
    export type CreateEditProjectMutationBody = EditProjectCreate
    export type CreateEditProjectMutationError = ErrorType<ErrorEnvelope>
    export type CreateEditProjectMutationVariables = {teamId: string;brandId: string;data: EditProjectCreate}

    /**
 * @summary Create Edit Project
 */
export const useCreateEditProject = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditProject>>, TError,CreateEditProjectMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEditProject>>,
        TError,
        CreateEditProjectMutationVariables,
        TContext
      > => {
      return useMutation(getCreateEditProjectMutationOptions(options), queryClient);
    }
    export const getOpenEditProjectFromAssetUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/from-asset`
}

/**
 * Live's Open in the editor (#668, spec S1c): the brand's project opened from this
 * library video (200), else a new one (201): from the body, or, for a video the editor
 * saved, as its render made it (live's `projectFile`, spec editor/reopen-saved-video.md).
 * Anything but a ready video of the brand's library is 422 at `asset_id`.
 * @summary Open Edit Project From Asset
 */
export const openEditProjectFromAsset = async (teamId: string,
    brandId: string,
    editProjectFromAsset: EditProjectFromAsset, options?: Parameters<typeof apiRequest>[1]): Promise<EditProject> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<EditProject>(getOpenEditProjectFromAssetUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editProjectFromAsset)
  }
);}





export const getOpenEditProjectFromAssetMutationKey = () => ['openEditProjectFromAsset'] as const;

export const getOpenEditProjectFromAssetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEditProjectFromAsset>>, TError,OpenEditProjectFromAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof openEditProjectFromAsset>>, TError,OpenEditProjectFromAssetMutationVariables, TContext> => {

const mutationKey = getOpenEditProjectFromAssetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openEditProjectFromAsset>>, OpenEditProjectFromAssetMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  openEditProjectFromAsset(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenEditProjectFromAssetMutationResult = NonNullable<Awaited<ReturnType<typeof openEditProjectFromAsset>>>
    export type OpenEditProjectFromAssetMutationBody = EditProjectFromAsset
    export type OpenEditProjectFromAssetMutationError = ErrorType<ErrorEnvelope>
    export type OpenEditProjectFromAssetMutationVariables = {teamId: string;brandId: string;data: EditProjectFromAsset}

    /**
 * @summary Open Edit Project From Asset
 */
export const useOpenEditProjectFromAsset = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openEditProjectFromAsset>>, TError,OpenEditProjectFromAssetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openEditProjectFromAsset>>,
        TError,
        OpenEditProjectFromAssetMutationVariables,
        TContext
      > => {
      return useMutation(getOpenEditProjectFromAssetMutationOptions(options), queryClient);
    }
    export const getDeleteEditProjectUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}`
}

/**
 * Delete the project, its renders' rows and its chat; the videos it saved stay in the
 * library. Its creator or an admin deletes it.
 * @summary Delete Edit Project
 */
export const deleteEditProject = async (teamId: string,
    brandId: string,
    projectId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteEditProjectUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteEditProjectMutationKey = () => ['deleteEditProject'] as const;

export const getDeleteEditProjectMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEditProject>>, TError,DeleteEditProjectMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEditProject>>, TError,DeleteEditProjectMutationVariables, TContext> => {

const mutationKey = getDeleteEditProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEditProject>>, DeleteEditProjectMutationVariables> = (props) => {
          const {teamId,brandId,projectId} = props ?? {};

          return  deleteEditProject(teamId,brandId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEditProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEditProject>>>

    export type DeleteEditProjectMutationError = ErrorType<ErrorEnvelope>
    export type DeleteEditProjectMutationVariables = {teamId: string;brandId: string;projectId: string}

    /**
 * @summary Delete Edit Project
 */
export const useDeleteEditProject = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEditProject>>, TError,DeleteEditProjectMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEditProject>>,
        TError,
        DeleteEditProjectMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteEditProjectMutationOptions(options), queryClient);
    }
    export const getGetEditProjectUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}`
}

/**
 * @summary Get Edit Project
 */
export const getEditProject = async (teamId: string,
    brandId: string,
    projectId: string, options?: Parameters<typeof apiRequest>[1]): Promise<EditProject> => {

  return apiRequest<EditProject>(getGetEditProjectUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEditProjectQueryKey = (teamId: string,
    brandId: string,
    projectId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}`
    ] as const;
    }


export const getGetEditProjectQueryOptions = <TData = Awaited<ReturnType<typeof getEditProject>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProject>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditProjectQueryKey(teamId,brandId,projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditProject>>> = ({ signal }) => getEditProject(teamId,brandId,projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getEditProject>>>
export type GetEditProjectQueryError = ErrorType<ErrorEnvelope>


export function useGetEditProject<TData = Awaited<ReturnType<typeof getEditProject>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditProject>>,
          TError,
          Awaited<ReturnType<typeof getEditProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditProject<TData = Awaited<ReturnType<typeof getEditProject>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditProject>>,
          TError,
          Awaited<ReturnType<typeof getEditProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditProject<TData = Awaited<ReturnType<typeof getEditProject>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProject>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Edit Project
 */

export function useGetEditProject<TData = Awaited<ReturnType<typeof getEditProject>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProject>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditProjectQueryOptions(teamId,brandId,projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getReplaceEditProjectUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}`
}

/**
 * Replace the whole project. 409 `VERSION_CONFLICT` when `version` is not current.
 * @summary Replace Edit Project
 */
export const replaceEditProject = async (teamId: string,
    brandId: string,
    projectId: string,
    editProjectUpdate: EditProjectUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<EditProject> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<EditProject>(getReplaceEditProjectUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editProjectUpdate)
  }
);}





export const getReplaceEditProjectMutationKey = () => ['replaceEditProject'] as const;

export const getReplaceEditProjectMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceEditProject>>, TError,ReplaceEditProjectMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceEditProject>>, TError,ReplaceEditProjectMutationVariables, TContext> => {

const mutationKey = getReplaceEditProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceEditProject>>, ReplaceEditProjectMutationVariables> = (props) => {
          const {teamId,brandId,projectId,data} = props ?? {};

          return  replaceEditProject(teamId,brandId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceEditProjectMutationResult = NonNullable<Awaited<ReturnType<typeof replaceEditProject>>>
    export type ReplaceEditProjectMutationBody = EditProjectUpdate
    export type ReplaceEditProjectMutationError = ErrorType<ErrorEnvelope>
    export type ReplaceEditProjectMutationVariables = {teamId: string;brandId: string;projectId: string;data: EditProjectUpdate}

    /**
 * @summary Replace Edit Project
 */
export const useReplaceEditProject = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceEditProject>>, TError,ReplaceEditProjectMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceEditProject>>,
        TError,
        ReplaceEditProjectMutationVariables,
        TContext
      > => {
      return useMutation(getReplaceEditProjectMutationOptions(options), queryClient);
    }
    export const getStartAssistAnswerUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/answers`
}

/**
 * Ask the AI assistant about the saved `version` (409 when it is not current): an
 * `editor.assist` job answers with a plan of edits. Free, within an hourly cap (429). Its
 * status arrives as the job's events.
 * @summary Start Assist Answer
 */
export const startAssistAnswer = async (teamId: string,
    brandId: string,
    projectId: string,
    assistRequest: AssistRequest,
    headers: StartAssistAnswerHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<AssistAnswer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AssistAnswer>(getStartAssistAnswerUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(assistRequest)
  }
);}





export const getStartAssistAnswerMutationKey = () => ['startAssistAnswer'] as const;

export const getStartAssistAnswerMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAssistAnswer>>, TError,StartAssistAnswerMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startAssistAnswer>>, TError,StartAssistAnswerMutationVariables, TContext> => {

const mutationKey = getStartAssistAnswerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startAssistAnswer>>, StartAssistAnswerMutationVariables> = (props) => {
          const {teamId,brandId,projectId,data,headers} = props ?? {};

          return  startAssistAnswer(teamId,brandId,projectId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartAssistAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof startAssistAnswer>>>
    export type StartAssistAnswerMutationBody = AssistRequest
    export type StartAssistAnswerMutationError = ErrorType<ErrorEnvelope>
    export type StartAssistAnswerMutationVariables = {teamId: string;brandId: string;projectId: string;data: AssistRequest;headers: StartAssistAnswerHeaders}

    /**
 * @summary Start Assist Answer
 */
export const useStartAssistAnswer = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAssistAnswer>>, TError,StartAssistAnswerMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startAssistAnswer>>,
        TError,
        StartAssistAnswerMutationVariables,
        TContext
      > => {
      return useMutation(getStartAssistAnswerMutationOptions(options), queryClient);
    }
    export const getGetAssistAnswerUrl = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/answers/${jobId}`
}

/**
 * One answer, with its plan once the job succeeded.
 * @summary Get Assist Answer
 */
export const getAssistAnswer = async (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AssistAnswer> => {

  return apiRequest<AssistAnswer>(getGetAssistAnswerUrl(teamId,brandId,projectId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssistAnswerQueryKey = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/answers/${jobId}`
    ] as const;
    }


export const getGetAssistAnswerQueryOptions = <TData = Awaited<ReturnType<typeof getAssistAnswer>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistAnswer>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistAnswerQueryKey(teamId,brandId,projectId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistAnswer>>> = ({ signal }) => getAssistAnswer(teamId,brandId,projectId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistAnswer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistAnswerQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistAnswer>>>
export type GetAssistAnswerQueryError = ErrorType<ErrorEnvelope>


export function useGetAssistAnswer<TData = Awaited<ReturnType<typeof getAssistAnswer>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistAnswer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistAnswer>>,
          TError,
          Awaited<ReturnType<typeof getAssistAnswer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistAnswer<TData = Awaited<ReturnType<typeof getAssistAnswer>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistAnswer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistAnswer>>,
          TError,
          Awaited<ReturnType<typeof getAssistAnswer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistAnswer<TData = Awaited<ReturnType<typeof getAssistAnswer>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistAnswer>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Assist Answer
 */

export function useGetAssistAnswer<TData = Awaited<ReturnType<typeof getAssistAnswer>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistAnswer>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistAnswerQueryOptions(teamId,brandId,projectId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getResetAssistMessagesUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/messages`
}

/**
 * Live's Reset chat: every message of the project's chat deleted.
 * @summary Reset Assist Messages
 */
export const resetAssistMessages = async (teamId: string,
    brandId: string,
    projectId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getResetAssistMessagesUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetAssistMessagesMutationKey = () => ['resetAssistMessages'] as const;

export const getResetAssistMessagesMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAssistMessages>>, TError,ResetAssistMessagesMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetAssistMessages>>, TError,ResetAssistMessagesMutationVariables, TContext> => {

const mutationKey = getResetAssistMessagesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetAssistMessages>>, ResetAssistMessagesMutationVariables> = (props) => {
          const {teamId,brandId,projectId} = props ?? {};

          return  resetAssistMessages(teamId,brandId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetAssistMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof resetAssistMessages>>>

    export type ResetAssistMessagesMutationError = ErrorType<ErrorEnvelope>
    export type ResetAssistMessagesMutationVariables = {teamId: string;brandId: string;projectId: string}

    /**
 * @summary Reset Assist Messages
 */
export const useResetAssistMessages = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAssistMessages>>, TError,ResetAssistMessagesMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetAssistMessages>>,
        TError,
        ResetAssistMessagesMutationVariables,
        TContext
      > => {
      return useMutation(getResetAssistMessagesMutationOptions(options), queryClient);
    }
    export const getListAssistMessagesUrl = (teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/messages?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/messages`
}

/**
 * The project's AI assistant chat, newest first, for every member (G11).
 * @summary List Assist Messages
 */
export const listAssistMessages = async (teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams, options?: Parameters<typeof apiRequest>[1]): Promise<AssistMessagePage> => {

  return apiRequest<AssistMessagePage>(getListAssistMessagesUrl(teamId,brandId,projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssistMessagesQueryKey = (teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssistMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAssistMessages>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssistMessages>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssistMessagesQueryKey(teamId,brandId,projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssistMessages>>> = ({ signal }) => listAssistMessages(teamId,brandId,projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssistMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssistMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAssistMessages>>>
export type ListAssistMessagesQueryError = ErrorType<ErrorEnvelope>


export function useListAssistMessages<TData = Awaited<ReturnType<typeof listAssistMessages>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params: undefined |  ListAssistMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssistMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssistMessages>>,
          TError,
          Awaited<ReturnType<typeof listAssistMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssistMessages<TData = Awaited<ReturnType<typeof listAssistMessages>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssistMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssistMessages>>,
          TError,
          Awaited<ReturnType<typeof listAssistMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssistMessages<TData = Awaited<ReturnType<typeof listAssistMessages>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssistMessages>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Assist Messages
 */

export function useListAssistMessages<TData = Awaited<ReturnType<typeof listAssistMessages>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params?: ListAssistMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssistMessages>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssistMessagesQueryOptions(teamId,brandId,projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAppendAssistMessageUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/assistant/messages`
}

/**
 * Save one message of the chat: the user's, or the assistant's answer or plan step. A
 * project keeps its newest 1,000.
 * @summary Append Assist Message
 */
export const appendAssistMessage = async (teamId: string,
    brandId: string,
    projectId: string,
    assistMessageCreate: AssistMessageCreate, options?: Parameters<typeof apiRequest>[1]): Promise<AssistMessage> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AssistMessage>(getAppendAssistMessageUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(assistMessageCreate)
  }
);}





export const getAppendAssistMessageMutationKey = () => ['appendAssistMessage'] as const;

export const getAppendAssistMessageMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendAssistMessage>>, TError,AppendAssistMessageMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof appendAssistMessage>>, TError,AppendAssistMessageMutationVariables, TContext> => {

const mutationKey = getAppendAssistMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appendAssistMessage>>, AppendAssistMessageMutationVariables> = (props) => {
          const {teamId,brandId,projectId,data} = props ?? {};

          return  appendAssistMessage(teamId,brandId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AppendAssistMessageMutationResult = NonNullable<Awaited<ReturnType<typeof appendAssistMessage>>>
    export type AppendAssistMessageMutationBody = AssistMessageCreate
    export type AppendAssistMessageMutationError = ErrorType<ErrorEnvelope>
    export type AppendAssistMessageMutationVariables = {teamId: string;brandId: string;projectId: string;data: AssistMessageCreate}

    /**
 * @summary Append Assist Message
 */
export const useAppendAssistMessage = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appendAssistMessage>>, TError,AppendAssistMessageMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof appendAssistMessage>>,
        TError,
        AppendAssistMessageMutationVariables,
        TContext
      > => {
      return useMutation(getAppendAssistMessageMutationOptions(options), queryClient);
    }
    export const getGetEditProjectChangesUrl = (teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/changes?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/changes`
}

/**
 * What each save after version `after` changed, oldest first (spec editor/live-sync.md),
 * for an open editor that is behind. `complete` is false, with no changes, when the log
 * cannot give them all: read the project whole. For every member (D6).
 * @summary Get Edit Project Changes
 */
export const getEditProjectChanges = async (teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams, options?: Parameters<typeof apiRequest>[1]): Promise<EditProjectChanges> => {

  return apiRequest<EditProjectChanges>(getGetEditProjectChangesUrl(teamId,brandId,projectId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEditProjectChangesQueryKey = (teamId: string,
    brandId: string,
    projectId: string,
    params?: GetEditProjectChangesParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/changes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEditProjectChangesQueryOptions = <TData = Awaited<ReturnType<typeof getEditProjectChanges>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectChanges>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditProjectChangesQueryKey(teamId,brandId,projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditProjectChanges>>> = ({ signal }) => getEditProjectChanges(teamId,brandId,projectId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditProjectChanges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditProjectChangesQueryResult = NonNullable<Awaited<ReturnType<typeof getEditProjectChanges>>>
export type GetEditProjectChangesQueryError = ErrorType<ErrorEnvelope>


export function useGetEditProjectChanges<TData = Awaited<ReturnType<typeof getEditProjectChanges>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectChanges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditProjectChanges>>,
          TError,
          Awaited<ReturnType<typeof getEditProjectChanges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditProjectChanges<TData = Awaited<ReturnType<typeof getEditProjectChanges>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectChanges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditProjectChanges>>,
          TError,
          Awaited<ReturnType<typeof getEditProjectChanges>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditProjectChanges<TData = Awaited<ReturnType<typeof getEditProjectChanges>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectChanges>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Edit Project Changes
 */

export function useGetEditProjectChanges<TData = Awaited<ReturnType<typeof getEditProjectChanges>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    params: GetEditProjectChangesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectChanges>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditProjectChangesQueryOptions(teamId,brandId,projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEditProjectMediaUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/media`
}

/**
 * Every distinct source of the saved timeline, with what the editor plays and shows
 * (spec editor/project-media.md), so a project opens with one read; one a render would
 * refuse is `gone`. For every member (D6).
 * @summary Get Edit Project Media
 */
export const getEditProjectMedia = async (teamId: string,
    brandId: string,
    projectId: string, options?: Parameters<typeof apiRequest>[1]): Promise<EditProjectMedia> => {

  return apiRequest<EditProjectMedia>(getGetEditProjectMediaUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEditProjectMediaQueryKey = (teamId: string,
    brandId: string,
    projectId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/media`
    ] as const;
    }


export const getGetEditProjectMediaQueryOptions = <TData = Awaited<ReturnType<typeof getEditProjectMedia>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectMedia>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditProjectMediaQueryKey(teamId,brandId,projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditProjectMedia>>> = ({ signal }) => getEditProjectMedia(teamId,brandId,projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditProjectMedia>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditProjectMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getEditProjectMedia>>>
export type GetEditProjectMediaQueryError = ErrorType<ErrorEnvelope>


export function useGetEditProjectMedia<TData = Awaited<ReturnType<typeof getEditProjectMedia>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectMedia>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditProjectMedia>>,
          TError,
          Awaited<ReturnType<typeof getEditProjectMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditProjectMedia<TData = Awaited<ReturnType<typeof getEditProjectMedia>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectMedia>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditProjectMedia>>,
          TError,
          Awaited<ReturnType<typeof getEditProjectMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditProjectMedia<TData = Awaited<ReturnType<typeof getEditProjectMedia>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectMedia>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Edit Project Media
 */

export function useGetEditProjectMedia<TData = Awaited<ReturnType<typeof getEditProjectMedia>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditProjectMedia>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditProjectMediaQueryOptions(teamId,brandId,projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEditRendersUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders`
}

/**
 * The project's latest renders, newest first.
 * @summary List Edit Renders
 */
export const listEditRenders = async (teamId: string,
    brandId: string,
    projectId: string, options?: Parameters<typeof apiRequest>[1]): Promise<EditRender[]> => {

  return apiRequest<EditRender[]>(getListEditRendersUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEditRendersQueryKey = (teamId: string,
    brandId: string,
    projectId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders`
    ] as const;
    }


export const getListEditRendersQueryOptions = <TData = Awaited<ReturnType<typeof listEditRenders>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditRenders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEditRendersQueryKey(teamId,brandId,projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEditRenders>>> = ({ signal }) => listEditRenders(teamId,brandId,projectId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEditRenders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEditRendersQueryResult = NonNullable<Awaited<ReturnType<typeof listEditRenders>>>
export type ListEditRendersQueryError = ErrorType<ErrorEnvelope>


export function useListEditRenders<TData = Awaited<ReturnType<typeof listEditRenders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditRenders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEditRenders>>,
          TError,
          Awaited<ReturnType<typeof listEditRenders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEditRenders<TData = Awaited<ReturnType<typeof listEditRenders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditRenders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEditRenders>>,
          TError,
          Awaited<ReturnType<typeof listEditRenders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEditRenders<TData = Awaited<ReturnType<typeof listEditRenders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditRenders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Edit Renders
 */

export function useListEditRenders<TData = Awaited<ReturnType<typeof listEditRenders>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEditRenders>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEditRendersQueryOptions(teamId,brandId,projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStartEditRenderUrl = (teamId: string,
    brandId: string,
    projectId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders`
}

/**
 * Render the saved `version` to an MP4, saved to the brand's library when it is done.
 * Free, within an hourly cap (429). Its status arrives as the job's events.
 * @summary Start Edit Render
 */
export const startEditRender = async (teamId: string,
    brandId: string,
    projectId: string,
    editRenderRequest: EditRenderRequest,
    headers: StartEditRenderHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<EditRender> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<EditRender>(getStartEditRenderUrl(teamId,brandId,projectId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(editRenderRequest)
  }
);}





export const getStartEditRenderMutationKey = () => ['startEditRender'] as const;

export const getStartEditRenderMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEditRender>>, TError,StartEditRenderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startEditRender>>, TError,StartEditRenderMutationVariables, TContext> => {

const mutationKey = getStartEditRenderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startEditRender>>, StartEditRenderMutationVariables> = (props) => {
          const {teamId,brandId,projectId,data,headers} = props ?? {};

          return  startEditRender(teamId,brandId,projectId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartEditRenderMutationResult = NonNullable<Awaited<ReturnType<typeof startEditRender>>>
    export type StartEditRenderMutationBody = EditRenderRequest
    export type StartEditRenderMutationError = ErrorType<ErrorEnvelope>
    export type StartEditRenderMutationVariables = {teamId: string;brandId: string;projectId: string;data: EditRenderRequest;headers: StartEditRenderHeaders}

    /**
 * @summary Start Edit Render
 */
export const useStartEditRender = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEditRender>>, TError,StartEditRenderMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startEditRender>>,
        TError,
        StartEditRenderMutationVariables,
        TContext
      > => {
      return useMutation(getStartEditRenderMutationOptions(options), queryClient);
    }
    export const getGetEditRenderUrl = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders/${jobId}`
}

/**
 * @summary Get Edit Render
 */
export const getEditRender = async (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<EditRender> => {

  return apiRequest<EditRender>(getGetEditRenderUrl(teamId,brandId,projectId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEditRenderQueryKey = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders/${jobId}`
    ] as const;
    }


export const getGetEditRenderQueryOptions = <TData = Awaited<ReturnType<typeof getEditRender>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditRender>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditRenderQueryKey(teamId,brandId,projectId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditRender>>> = ({ signal }) => getEditRender(teamId,brandId,projectId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && projectId !== null && projectId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditRender>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditRenderQueryResult = NonNullable<Awaited<ReturnType<typeof getEditRender>>>
export type GetEditRenderQueryError = ErrorType<ErrorEnvelope>


export function useGetEditRender<TData = Awaited<ReturnType<typeof getEditRender>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditRender>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditRender>>,
          TError,
          Awaited<ReturnType<typeof getEditRender>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditRender<TData = Awaited<ReturnType<typeof getEditRender>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditRender>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditRender>>,
          TError,
          Awaited<ReturnType<typeof getEditRender>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditRender<TData = Awaited<ReturnType<typeof getEditRender>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditRender>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Edit Render
 */

export function useGetEditRender<TData = Awaited<ReturnType<typeof getEditRender>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditRender>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditRenderQueryOptions(teamId,brandId,projectId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStartEditRenderFileUrl = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders/${jobId}/file`
}

/**
 * Where the browser making a render's file (`made_in` browser) posts it: a policy for
 * the render's own object, of `video/mp4` and exactly `bytes`, for 15 minutes (spec
 * editor/fast-save). The render's maker's alone (403); 409 once it is taking its file in
 * or has settled; 404 for a render made on the server.
 * @summary Start Edit Render File
 */
export const startEditRenderFile = async (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,
    editRenderFileRequest: EditRenderFileRequest, options?: Parameters<typeof apiRequest>[1]): Promise<EditRenderFile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<EditRenderFile>(getStartEditRenderFileUrl(teamId,brandId,projectId,jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editRenderFileRequest)
  }
);}





export const getStartEditRenderFileMutationKey = () => ['startEditRenderFile'] as const;

export const getStartEditRenderFileMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEditRenderFile>>, TError,StartEditRenderFileMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startEditRenderFile>>, TError,StartEditRenderFileMutationVariables, TContext> => {

const mutationKey = getStartEditRenderFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startEditRenderFile>>, StartEditRenderFileMutationVariables> = (props) => {
          const {teamId,brandId,projectId,jobId,data} = props ?? {};

          return  startEditRenderFile(teamId,brandId,projectId,jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartEditRenderFileMutationResult = NonNullable<Awaited<ReturnType<typeof startEditRenderFile>>>
    export type StartEditRenderFileMutationBody = EditRenderFileRequest
    export type StartEditRenderFileMutationError = ErrorType<ErrorEnvelope>
    export type StartEditRenderFileMutationVariables = {teamId: string;brandId: string;projectId: string;jobId: string;data: EditRenderFileRequest}

    /**
 * @summary Start Edit Render File
 */
export const useStartEditRenderFile = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startEditRenderFile>>, TError,StartEditRenderFileMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startEditRenderFile>>,
        TError,
        StartEditRenderFileMutationVariables,
        TContext
      > => {
      return useMutation(getStartEditRenderFileMutationOptions(options), queryClient);
    }
    export const getSentEditRenderFileUrl = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders/${jobId}/file/sent`
}

/**
 * The browser posted the render's file: the render takes it in now, not at its next
 * poll. Harmless before the file. The render's maker's alone (403).
 * @summary Sent Edit Render File
 */
export const sentEditRenderFile = async (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<EditRender> => {

  return apiRequest<EditRender>(getSentEditRenderFileUrl(teamId,brandId,projectId,jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSentEditRenderFileMutationKey = () => ['sentEditRenderFile'] as const;

export const getSentEditRenderFileMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sentEditRenderFile>>, TError,SentEditRenderFileMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof sentEditRenderFile>>, TError,SentEditRenderFileMutationVariables, TContext> => {

const mutationKey = getSentEditRenderFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sentEditRenderFile>>, SentEditRenderFileMutationVariables> = (props) => {
          const {teamId,brandId,projectId,jobId} = props ?? {};

          return  sentEditRenderFile(teamId,brandId,projectId,jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SentEditRenderFileMutationResult = NonNullable<Awaited<ReturnType<typeof sentEditRenderFile>>>

    export type SentEditRenderFileMutationError = ErrorType<ErrorEnvelope>
    export type SentEditRenderFileMutationVariables = {teamId: string;brandId: string;projectId: string;jobId: string}

    /**
 * @summary Sent Edit Render File
 */
export const useSentEditRenderFile = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sentEditRenderFile>>, TError,SentEditRenderFileMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sentEditRenderFile>>,
        TError,
        SentEditRenderFileMutationVariables,
        TContext
      > => {
      return useMutation(getSentEditRenderFileMutationOptions(options), queryClient);
    }
    export const getHandEditRenderToServerUrl = (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/edit-projects/${projectId}/renders/${jobId}/server`
}

/**
 * The browser could not finish this render's file: the render making it now. One
 * waiting for its file is canceled and its snapshot rendered on the server, with its own
 * job; one that has its file, or is made on the server, is answered as it is. The
 * render's maker's alone (403).
 * @summary Hand Edit Render To Server
 */
export const handEditRenderToServer = async (teamId: string,
    brandId: string,
    projectId: string,
    jobId: string,
    headers: HandEditRenderToServerHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<EditRender> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<EditRender>(getHandEditRenderToServerUrl(teamId,brandId,projectId,jobId),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getHandEditRenderToServerMutationKey = () => ['handEditRenderToServer'] as const;

export const getHandEditRenderToServerMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handEditRenderToServer>>, TError,HandEditRenderToServerMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof handEditRenderToServer>>, TError,HandEditRenderToServerMutationVariables, TContext> => {

const mutationKey = getHandEditRenderToServerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handEditRenderToServer>>, HandEditRenderToServerMutationVariables> = (props) => {
          const {teamId,brandId,projectId,jobId,headers} = props ?? {};

          return  handEditRenderToServer(teamId,brandId,projectId,jobId,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandEditRenderToServerMutationResult = NonNullable<Awaited<ReturnType<typeof handEditRenderToServer>>>

    export type HandEditRenderToServerMutationError = ErrorType<ErrorEnvelope>
    export type HandEditRenderToServerMutationVariables = {teamId: string;brandId: string;projectId: string;jobId: string;headers: HandEditRenderToServerHeaders}

    /**
 * @summary Hand Edit Render To Server
 */
export const useHandEditRenderToServer = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handEditRenderToServer>>, TError,HandEditRenderToServerMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handEditRenderToServer>>,
        TError,
        HandEditRenderToServerMutationVariables,
        TContext
      > => {
      return useMutation(getHandEditRenderToServerMutationOptions(options), queryClient);
    }
    export const getListCaptionPresetsUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/caption-presets`
}

/**
 * The member's own caption presets, oldest first, then live's six system presets.
 * @summary List Caption Presets
 */
export const listCaptionPresets = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CaptionPreset[]> => {

  return apiRequest<CaptionPreset[]>(getListCaptionPresetsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCaptionPresetsQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/caption-presets`
    ] as const;
    }


export const getListCaptionPresetsQueryOptions = <TData = Awaited<ReturnType<typeof listCaptionPresets>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaptionPresets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCaptionPresetsQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCaptionPresets>>> = ({ signal }) => listCaptionPresets(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCaptionPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCaptionPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listCaptionPresets>>>
export type ListCaptionPresetsQueryError = ErrorType<ErrorEnvelope>


export function useListCaptionPresets<TData = Awaited<ReturnType<typeof listCaptionPresets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaptionPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCaptionPresets>>,
          TError,
          Awaited<ReturnType<typeof listCaptionPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCaptionPresets<TData = Awaited<ReturnType<typeof listCaptionPresets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaptionPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCaptionPresets>>,
          TError,
          Awaited<ReturnType<typeof listCaptionPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCaptionPresets<TData = Awaited<ReturnType<typeof listCaptionPresets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaptionPresets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Caption Presets
 */

export function useListCaptionPresets<TData = Awaited<ReturnType<typeof listCaptionPresets>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCaptionPresets>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCaptionPresetsQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateCaptionPresetUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/caption-presets`
}

/**
 * Live's "Save style as preset": the look, named, kept for the member who saved it.
 * @summary Create Caption Preset
 */
export const createCaptionPreset = async (teamId: string,
    captionPresetCreate: CaptionPresetCreate, options?: Parameters<typeof apiRequest>[1]): Promise<CaptionPreset> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CaptionPreset>(getCreateCaptionPresetUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(captionPresetCreate)
  }
);}





export const getCreateCaptionPresetMutationKey = () => ['createCaptionPreset'] as const;

export const getCreateCaptionPresetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCaptionPreset>>, TError,CreateCaptionPresetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createCaptionPreset>>, TError,CreateCaptionPresetMutationVariables, TContext> => {

const mutationKey = getCreateCaptionPresetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCaptionPreset>>, CreateCaptionPresetMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  createCaptionPreset(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCaptionPresetMutationResult = NonNullable<Awaited<ReturnType<typeof createCaptionPreset>>>
    export type CreateCaptionPresetMutationBody = CaptionPresetCreate
    export type CreateCaptionPresetMutationError = ErrorType<ErrorEnvelope>
    export type CreateCaptionPresetMutationVariables = {teamId: string;data: CaptionPresetCreate}

    /**
 * @summary Create Caption Preset
 */
export const useCreateCaptionPreset = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCaptionPreset>>, TError,CreateCaptionPresetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCaptionPreset>>,
        TError,
        CreateCaptionPresetMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCaptionPresetMutationOptions(options), queryClient);
    }
    export const getDeleteCaptionPresetUrl = (teamId: string,
    presetId: string,) => {




  return `/api/v1/teams/${teamId}/caption-presets/${presetId}`
}

/**
 * Its maker deletes their preset (anyone else's is 404); live's system presets stay.
 * @summary Delete Caption Preset
 */
export const deleteCaptionPreset = async (teamId: string,
    presetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteCaptionPresetUrl(teamId,presetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCaptionPresetMutationKey = () => ['deleteCaptionPreset'] as const;

export const getDeleteCaptionPresetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCaptionPreset>>, TError,DeleteCaptionPresetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCaptionPreset>>, TError,DeleteCaptionPresetMutationVariables, TContext> => {

const mutationKey = getDeleteCaptionPresetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCaptionPreset>>, DeleteCaptionPresetMutationVariables> = (props) => {
          const {teamId,presetId} = props ?? {};

          return  deleteCaptionPreset(teamId,presetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCaptionPresetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCaptionPreset>>>

    export type DeleteCaptionPresetMutationError = ErrorType<ErrorEnvelope>
    export type DeleteCaptionPresetMutationVariables = {teamId: string;presetId: string}

    /**
 * @summary Delete Caption Preset
 */
export const useDeleteCaptionPreset = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCaptionPreset>>, TError,DeleteCaptionPresetMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCaptionPreset>>,
        TError,
        DeleteCaptionPresetMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCaptionPresetMutationOptions(options), queryClient);
    }
